import { config } from "./config";
import "./styles/App.scss";

function Banner() {
  const getBackground = () => {
    const background = config.get("background");
    if (background) {
      return (
        <img
          className="background-img"
          src={config.get("background")}
          alt="background"
        ></img>
      );
    }
  };
  return (
    <div className="banner-wrapper">
      <button
        className={"banner " + config.get("bannerClass")}
        onClick={() => {
          window.open(config.get("link"));
        }}
      >
        {getBackground()}
        <span>join</span>
        <img src={config.get("logo")} alt="logo"></img>
        {getBackground()}
      </button>
    </div>
  );
}

export default Banner;
